




export function setupMobileNav () {
    // Setup mobile nav toggle button
    const toggleBtn = document.querySelector('.toggle-mobile-nav');

    toggleBtn.addEventListener('click', () => {
        document.querySelector('body').classList.toggle('mobile-nav-active');
    });


    // Add logo to mobile nav
    const mainMenu = document.querySelector('.main-menu');
    const logo = document.querySelector('.main-header .logo');

    mainMenu.prepend(logo.cloneNode());
}
